import { makeAjaxCall } from "./utils";

export function storeCartInBackend(cart_data, cart_lines, empty_cart) {
  const data = {
    cart_data: cart_data,
    cart_lines: cart_lines,
  };
  if (empty_cart) {
    data.empty_cart = true
  }
  return makeAjaxCall({
    url: $("#API_CART_URL").val(),
    method: "POST",
    data,
  });
}
